export enum CatalogDomain {
  PRODUCTS = "products",
  PRODUCT_GROUPS = "productGroups",
  MODIFIERS = "modifiers",
  MODIFIER_GROUPS = "modifierGroups",
  COURSES = "courses",
  UNITS = "units",
  SUPPLIERS = "suppliers",
  EXTRA_PRODUCT_FIELDS = "extraProductFields",
  BOOKKEEPING_ACCOUNTS = "bookkeepingAccounts",
  PREP_STATIONS = "prepStations",
  OFFERS = "offers",
  PRODUCT_PAGES = "productPages",
  LAYOUTS = "layouts",
}
